const getters = {
  device: state => state.app.device,
  token: state => state.user.token,
  language: state => state.app.language,
  name: state => state.user.name,
  menuList: state => state.user.menu,
  brand: state => state.app.brand,
  trackingNo: state => state.user.trackingNo
}
export default getters
